"use client";

// ============================================================
// ANSICHTSSACHE-AGENT – Das letzte Netz
// ============================================================
// Greift nur, wenn der Rahmen SELBST faellt (`app/layout.tsx`,
// etwa weil die Datenbank beim Lesen des Produktnamens nicht
// antwortet) — alles darunter faengt das `error.tsx` des
// jeweiligen Bereichs. Dieses Blatt ersetzt den Rahmen und muss
// deshalb `<html>` und `<body>` selbst mitbringen; es haengt an
// keinem Stylesheet, keiner Schrift und keinem Baustein der
// Anwendung, weil genau die gerade gescheitert sein koennen.
// Hell und dunkel nach der Systemeinstellung, weil das Skript
// des Rahmens, das sonst das Thema setzt, hier nicht laeuft.
//
// Im Entwicklungsserver zeigt Next statt dessen seine eigene
// Fehleransicht; dieses Blatt ist nur im Produktionsbau zu sehen.
// ============================================================

const STIL = `
  :root { color-scheme: light dark; }
  body { margin: 0; min-height: 100vh; display: flex; align-items: center; justify-content: center;
    font: 14px/1.5 system-ui, -apple-system, "Segoe UI", sans-serif; background: #f6f4f2; color: #1c1a18; }
  main { max-width: 420px; margin: 24px; padding: 48px 32px; text-align: center; background: #fff;
    border-radius: 12px; box-shadow: 0 1px 2px rgb(0 0 0 / 0.06), 0 8px 24px rgb(0 0 0 / 0.08); }
  h1 { margin: 0 0 8px; font-size: 18px; font-weight: 600; }
  p { margin: 0 0 24px; color: #6b6561; }
  .wege { display: flex; flex-wrap: wrap; justify-content: center; gap: 8px; }
  button, a { box-sizing: border-box; height: 36px; padding: 0 14px; border-radius: 8px; font: inherit;
    display: inline-flex; align-items: center; cursor: pointer; text-decoration: none; }
  button { border: 0; background: #b8322e; color: #fff; }
  a { border: 1px solid #c9c4bf; background: #fff; color: #1c1a18; }
  .kennung { margin: 24px 0 0; font-size: 12px; color: #8a847e; }
  @media (prefers-color-scheme: dark) {
    body { background: #0e0d0c; color: #f1eeeb; }
    main { background: #1a1816; box-shadow: 0 0 0 1px rgb(255 255 255 / 0.06); }
    p { color: #a39d97; }
    a { background: #1a1816; color: #f1eeeb; border-color: #3a3632; }
  }
`;

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="de">
      <body>
        <style>{STIL}</style>
        <main>
          <h1>Da ist etwas schiefgegangen</h1>
          <p>Die Anwendung konnte nicht geladen werden. Versuch es noch einmal.</p>
          <div className="wege">
            <button type="button" onClick={() => reset()}>
              Noch einmal versuchen
            </button>
            {/* eslint-disable-next-line @next/next/no-html-link-for-pages -- bewusst ein voller Seitenaufruf: der Router der Anwendung kann hier selbst gescheitert sein */}
            <a href="/">Zur Startseite</a>
          </div>
          {error.digest && <p className="kennung">Kennung für die Fehlersuche: {error.digest}</p>}
        </main>
      </body>
    </html>
  );
}
